import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { FollowsProvider } from "@/context/FollowsContext";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Wishlist from "@/pages/Wishlist";
import Product from "@/pages/Product";
import Checkout from "@/pages/Checkout";
import Messages from "@/pages/Messages";
import Orders from "@/pages/Orders";
import Seller from "@/pages/Seller";
import AdminListings from "@/pages/AdminListings";

const AppRouter = () => {
  const location = useLocation();
  // Detect session_id synchronously during render to avoid races
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/wishlist" element={<Wishlist />} />
      <Route path="/product/:id" element={<Product />} />
      <Route path="/checkout/:id" element={<Checkout />} />
      <Route path="/messages" element={<Messages />} />
      <Route path="/messages/:convId" element={<Messages />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/seller/:sellerId" element={<Seller />} />
      <Route path="/admin/listings" element={<AdminListings />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <FollowsProvider>
          <Toaster position="bottom-right" mobileOffset={{ bottom: 96 }} />
          <AppRouter />
        </FollowsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
